import React from "react";
import Separator from "../../common/separator";
import { ProjectData } from "../../data/projects";
import ProjectCard from "./project-card";
//import { Link } from "react-router-dom";

function Projects() {
  const data = ProjectData;
  return (
    <div className="flex flex-col flex-1">
      <label className=" text-3xl font-semibold">Projects</label>
      <Separator />
      <div>
      {/* data.filter(y => y.id < 5).map((project) */}
        {data.map((project) => {
          return <ProjectCard project={project} />;
        })}
      </div>
      {/* <Link to="" className="text-center text-xl font-semibold mb-7 bg-blue-400 w-36 mx-auto p-2">View all</Link> */}
    </div>
  );
}

export default Projects;